export default {
  apiKey: "AIzaSyCLZna4UNCg7UUnBFpbcxnsS6lgOVieKUU",
    authDomain: "smartamu-826a8.firebaseapp.com",
  projectId: "smartamu-826a8",
  storageBucket: "smartamu-826a8.appspot.com",
  messagingSenderId: "447413721416",
  appId: "1:447413721416:web:b3257b06645a2117467b7d",
  measurementId: "G-ELKRRT3Q56"
};
